module.exports = __webpack_public_path__ + "img/TvDip-logo_small.d63bcf.png";